/* unplugin-vue-components disabled */import script from "./CyhdDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./CyhdDetail.vue?vue&type=script&lang=ts&setup=true"

import "./CyhdDetail.vue?vue&type=style&index=0&id=c3478766&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3478766"]])

export default __exports__